class BESSAppHasItemsTypeDependency extends BESSAppProjectDependency {

    constructor(editorId, dependencyHandler) {
        super();
        this.subscribeToEvents(
            BESSAppHasItemsDependencyEvent.eventFor(editorId),
            (x) => dependencyHandler.handle(x)
        );
    }
}